import React, { ReactElement, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import {
  useLegislativnyMaterialDetail,
} from '../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';
import routes from '../../routing/routes';
import Layout from '../Layout';
import GlobalErrors from '../../module/GlobalErrors';
import SecuredPage from '../../module/SecuredPage';
import { StadiumMaterialuEnum } from '../../model/legislativnyMaterial/StadiumMaterialu';
import { UserRoleEnum } from '../../model/currentuser/UserRole';
import PageHeadingWithBackButton from '../../module/PageHeadingWithBackButton';
import MpkCancel from '../../module/PracovnyKrok/MpkCancel';
import SuccessMessages from '../../module/SuccessMessages';

const MpkCancelPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.ZRUSIT_MPK);

  const currentLocation = useLocation();

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Legislatívne procesy',
          to: routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Zrušenie Pripomienkového konania',
          to: currentLocation.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.stadium?.hodnota === StadiumMaterialuEnum.MPK}
          allowForRoles={[UserRoleEnum.SUPERADMIN]}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Zrušenie Pripomienkového konania"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <MpkCancel isAdmin materialDetail={materialDetail} />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default MpkCancelPage;
